import { InfluencerIdProvider } from '@client/new/contexts/InfluencerIdContext';
import { useCollectionVM } from './collection.viewModel';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { Program } from './program';
import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import { InjectedRouter, PlainRoute, RouteComponentProps } from 'react-router';
import { RoutingProvider } from '@client/new/hooks/useRouting';

type Props = RouteComponentProps<
  {
    influencerId: string;
    programId: string;
    route: PlainRoute<unknown>;
    router: InjectedRouter;
  },
  unknown
>;

export const CollectionPage = (props: Props) => {
  const { params, router, route } = props;
  const { programId, influencerId } = params;

  const data = useCollectionVM({
    collectionId: Number(programId),
    creatorId: Number(influencerId),
    router,
    route,
  });

  const routing = { router: props.router, route: props.route };

  return (
    <RoutingProvider routing={routing}>
      <InfluencerIdProvider value={Number(influencerId)}>
        <AsyncRenderer
          loadRender={<TableLoader rows={5} />}
          data={data}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderer={(p) => <Program {...(p as any)} />}
        />
      </InfluencerIdProvider>
    </RoutingProvider>
  );
};
